import { createSlice } from "@reduxjs/toolkit";

const emotionEditSlice = createSlice({
  name: "emotionEdit",
  initialState: {
    isEmotionEditOpen: false,
  },
  reducers: {
    toogleEmotionEdit: (state) => {
      state.isEmotionEditOpen = !state.isEmotionEditOpen;
    },
  },
});

export const { toogleEmotionEdit } = emotionEditSlice.actions;
export default emotionEditSlice.reducer;